module.exports = __webpack_public_path__ + "static/media/SnackGift.785e6f56.gif";